interface CanDragVisitParams {
  visit: unknown;
  reviewMode?: boolean;
}

const canDragVisit = (): boolean => {
  return true;
};

export default canDragVisit;
